export const MEETING_PARTICIPANTS_TOPIC = 'meeting-participants.state'

export interface TrackedParticipant {
  id: number
  name: string | null
  isHost: boolean
  isSelf?: boolean
  email: string | null
  isSpeaking: boolean
  hasSpoken: boolean
  joinedAtMs: number | null
  lastSpeechStartMs: number | null
  lastSpeechEndMs: number | null
  totalSpeechMs: number
  speechCount: number
  /**
   * AX-derived mute state. Only meaningful for participants whose AX layer
   * exposes mute info: Google Meet (self only), Zoom (all participants), Teams
   * (all participants). `true` = muted, `false` = unmuted, `null`/`undefined`
   * = unknown. Recall-event-driven participants leave this unset.
   */
  isMuted?: boolean | null
  /**
   * `true` iff `isSelf` was promoted by the fuzzy branch of the JS-side
   * self-name matcher. Fuzzy matches are useful for UI labeling but not strong
   * enough to drive the audio gate by themselves.
   */
  isSelfFuzzy?: boolean
}

export interface MeetingParticipantsSnapshot {
  revision: number
  participants: Record<number, TrackedParticipant>
}

export const EMPTY_MEETING_PARTICIPANTS_SNAPSHOT: MeetingParticipantsSnapshot = {
  revision: 0,
  participants: {},
}
